import { render, staticRenderFns } from "./base-register.vue?vue&type=template&id=52afc858&scoped=true&"
import script from "./base-register.vue?vue&type=script&lang=js&"
export * from "./base-register.vue?vue&type=script&lang=js&"
import style0 from "./base-register.vue?vue&type=style&index=0&id=52afc858&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52afc858",
  null
  
)

export default component.exports